module.exports = __webpack_public_path__ + "static/media/article.d910ae66.jpg";